import { render, staticRenderFns } from "./SectorBox.vue?vue&type=template&id=4192d877&"
import script from "./SectorBox.vue?vue&type=script&lang=js&"
export * from "./SectorBox.vue?vue&type=script&lang=js&"
import style0 from "./SectorBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
